import { observer } from 'mobx-react';
import { OptionsCheckbox, OptionDescription } from 'owa-options-controls';
import isConfettiEnabled from '../selectors/isConfettiEnabled';
import toggleConfettiOption from '../data/mutators/toggleConfettiOption';
import * as React from 'react';
import strings from 'owa-strings/owa-options-strings';
export default observer(function ConfettiFull() {
    return (React.createElement("div", null,
        React.createElement(OptionDescription, null,
            " ",
            strings.options_mail_confettiDescription,
            " "),
        React.createElement(OptionsCheckbox, { checked: isConfettiEnabled(), label: strings.options_mail_confettiCheckboxLabel, onChange: onConfettiCheckboxClicked })));
});
var onConfettiCheckboxClicked = function (ev, checked) { return toggleConfettiOption(checked); };
//# sourceMappingURL=ConfettiFull.js.map